import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  dropzone: {
    boxSizing: 'content-box',
    height: theme.spacing(97),
    border: '1px solid #ABAFB3',
    borderRadius: 20,
    transition: '.12s ease-in',
  },
  bulkUploadContent: {
    maxWidth: theme.spacing(408),
  },
  bulkUploadContainer: {
    padding: theme.spacing(47, 0, 38.5),
    flex: 1,
  },
  hoverableDropzone: {
    '&:hover': {
      cursor: 'pointer',
      color: theme.palette.grey[200],
      borderColor: theme.palette.secondary.main,
      margin: -1,
      borderWidth: 2,
    },
  },
  activeDropzone: {
    borderColor: theme.palette.secondary.main,
    margin: -1,
    borderWidth: 2,
  },
  dropzoneTitle: {
    color: theme.palette.common.black,
    fontSize: 32,
    lineHeight: '57px',
  },
  dropzoneSubtitle: {
    fontWeight: 500,
    lineHeight: '21px',
  },
  loadingMsg: {
    fontSize: 18,
    color: theme.palette.primary.dark,
  },
  threeDots: {
    position: 'absolute',
    marginRight: '2px',
    '&:after': {
      overflow: 'hidden',
      display: 'inline-block',
      verticalAlign: 'bottom',
      animation: '$ellipsis steps(4, end) 900ms infinite',
      content: '"\\2026"',
      width: '0px',
    },
  },

  '@keyframes ellipsis': {
    to: {
      width: '20px',
    },
  },
}));
